import { type AppDownloadLinksData } from '@/features/cms/components/CMS/types'
import { CMSErrorHandler } from '@/features/cms/components/CMS/CMSErrorHandler'
import { AppBadges } from '@/features/shared/components/AppBadges'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'

/**
 * This component corresponds to the `app_download_links` content type in the CMS.
 *
 * - **Staging** - https://cms-staging.shipt.com/content-type/pool/app_download_links
 * - **Production** - https://cms.shipt.com/content-type/pool/app_download_links
 */
export const AppDownloadLinks = ({
  content_type_id,
  id,
  data: { is_shopper_page },
}: AppDownloadLinksData) => {
  try {
    return (
      <AppBadges
        {...getCMSWrapperProps({ content_type_id, id })}
        openInNewTab={false}
        isShopper={is_shopper_page}
      />
    )
  } catch (error) {
    return <CMSErrorHandler error={error} contentTypeId={content_type_id} id={id} />
  }
}
